import { Component, effect, inject, ChangeDetectionStrategy } from '@angular/core';
import { EndpointCache } from '@xanadu/cache';
import { PanelComponent, Register } from '@xanadu/core';
import { Endpoint } from '@xanadu/model';

@Component({
    selector: 'app-endpoint-panel',
    templateUrl: './endpoint-panel.component.html',
    styleUrls: ['./endpoint-panel.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
@Register('endpoint-panel')
export class EndpointPanelComponent extends PanelComponent<Endpoint> {
    private readonly endpointCache = inject(EndpointCache);

    private tabEndpoint = { caption: 'Endpoint', active: true, hidden: false };

    metaExpansionRequest: any = { title: 'Request', description: 'Request url and method' };
    metaExpansionGlossary: any = { title: 'Headers', description: 'Request headers' };
    metaExpansionBody: any = { title: 'Body', description: 'Request body' };
    metaGlossary: any = { label: { id: 'key', name: 'Header Key', style: '{"width": "24%"}' }, value: { id: 'value', name: 'Header Value', style: '{"width": "72%"}' } };

    protected override get nodeType(): string | undefined {
        return 'import';
    }

    constructor(
    ) {
        super();

        effect(() => {
            const model = this.model();

            if (model?.custome) {
                const custome = model.custome;
                custome.expansionRequest = custome.expansionRequest || { expanded: true };
                custome.expansionGlossary = custome.expansionGlossary || { expanded: true };
                custome.expansionBody = custome.expansionBody || { expanded: true };
            }
        });
    }

    protected override setup(endpoint: Endpoint): void {
        super.setup(endpoint);

        this.tabs = [
            this.tabEndpoint
        ];
        this.tabSelected = this.tabEndpoint;
    }

    protected override load(endpoint: Endpoint, form: any): string | undefined {
        super.load(endpoint, form);

        endpoint.data = form;
        return;
    }

    protected override refresh(endpoint: Endpoint): void {
        super.refresh(endpoint);

        this.endpointCache.update();
    }
}
